/* Woodlit sale features (SB13, 14 Oct 2026). Hides every [data-wl-sale-end] element outside its campaign window
   (also on a cached page), runs the lawful countdown to the fixed end printed in the markup (never from storage, so
   it is the same for every visitor and cannot restart; every unit labelled, "17 d 2 h 44 min", days only while a day
   or more is left, hours only while an hour or more is left, rounded up to the minute), passes the
   strip height to the CSS on the transparent home header. Klarna's own message is left as Klarna draws it (no panel:
   it already has its own frame, and a panel added after Klarna draws would move the page).
   Product page (fix 15 Oct): places the savings pill so the buy box is never taller than live when that is possible
   (live shows a red Sale chip in the badge row; SB13 keeps it there as an invisible place holder, data-wl-keep):
   the price line, else the badge row in the chip's place, else the short form (minus and the amount) in either
   place, else the price line on its own line. The campaign tag takes the chip's place only if that adds no line.
   Measured after the web fonts load, again on a width change and when the product form is re-rendered; every try
   happens inside one task, so nothing flickers or moves.
   Header A (2 Nov 2026): the campaign bar in the top bar (snippets/wl-sale.liquid part 'topbar') takes the longest
   form that fits its box: phones (to 749px) always the short line with the timer pill (tighter type if the two
   lines or the pill would not fit); from 750px full, no link, short with timer, then short with pill. Re-measured
   after the web fonts load, on a width change and on every countdown tick (the digits change width).
   From 750px the bar's line box first keeps clear of the shop switcher (fix 2 Nov 2026: "Lietuviškai" on woodlit.lt
   ran 8px under it): --wl-tbs-side = the switcher's room from the right edge plus a 16px gap, at least 136px, on
   both sides so the line stays centred; a longer form then only shows where it fits inside that box.
   Polish (2 Nov 2026): every countdown number also gets data-n = its digit count; wl-sale.css gives the top bar's
   minutes a fixed slot per digit count (Poppins has no tabular figures), so the timer keeps its width from minute
   to minute.
   QA: window.wlSaleAt(ms) re-checks everything as if the clock read ms; wlSaleAt() returns to the real clock;
   window.wlSaleFit() re-places the pill and returns the choice; window.wlSaleTopFit() re-fits the top bar. */
(function(){
  var off=0,timer;
  function now(){return Date.now()+off}
  function q(s,r){return (r||document).querySelectorAll(s)}
  function num(n,v){n.textContent=v;n.setAttribute('data-n',String(v).length)}
  function run(){
    var t=now(),next=0;
    q('[data-wl-sale-end]').forEach(function(el){
      var s=+el.getAttribute('data-wl-sale-start')||0,e=+el.getAttribute('data-wl-sale-end');
      el.hidden=!(t>=s&&t<e);
      var w=t<s?s-t:e-t;
      if(w>0&&(!next||w<next))next=w;
    });
    q('[data-wl-cd]').forEach(function(el){
      var r=+el.getAttribute('data-end')-t,bar=el.closest('[data-wl-sale-end]');
      el.hidden=r<=0;
      if(r<=0){if(bar)bar.hidden=true;return}
      var m=Math.ceil(r/60000),d=Math.floor(m/1440),h=Math.floor(m%1440/60),u=el.querySelector('[data-du]'),w=el.querySelector('[data-d-wrap]'),hw=el.querySelector('[data-h-wrap]');
      num(el.querySelector('[data-d]'),d);
      if(u)u.textContent=u.getAttribute(d==1?'data-one':'data-other');
      if(w)w.hidden=d<1;
      if(hw)hw.hidden=d<1&&h<1;
      num(el.querySelector('[data-h]'),h);
      num(el.querySelector('[data-m]'),m%60);
      var w2=r%60000||60000;
      if(!next||w2<next)next=w2;
    });
    return next;
  }
  var fitted='';
  function fit(){
    var pp=document.querySelector('[data-wl-pill="price"]');
    if(!pp||!pp.parentElement)return '';
    var bp=document.querySelector('[data-wl-pill="badge"]'),kp=document.querySelector('[data-wl-keep]'),tg=document.querySelector('[data-wl-tag]'),pb=pp.parentElement;
    function y(){return pb.getBoundingClientRect().bottom}
    function set(a,b,k,t,s){
      pp.classList.toggle('is-on',!!a);pp.classList.toggle('is-short',!!s);
      if(bp){bp.classList.toggle('is-on',!!b);bp.classList.toggle('is-short',!!s)}
      if(kp)kp.classList.toggle('is-off',!k);
      if(tg)tg.classList.toggle('is-on',!!t);
    }
    set(0,0,1,0,0);
    var y0=y()+1.5,tries=[[1,0,1,0,0,'price'],[0,1,0,0,0,'badge'],[1,0,1,0,1,'price short'],[0,1,0,0,1,'badge short']],i,c='';
    for(i=0;i<tries.length;i++){
      if(tries[i][1]&&!bp)continue;
      set.apply(null,tries[i]);
      if(y()<=y0){c=tries[i][5];break}
    }
    if(!c){c='price, own line';set(1,0,1,0,0);var ya=y();set(1,0,0,0,0);if(y()>ya)set(1,0,1,0,0)}
    if(tg&&!tg.hidden){
      var a=pp.classList.contains('is-on'),b=!!bp&&bp.classList.contains('is-on'),s=pp.classList.contains('is-short'),k=!!kp&&!kp.classList.contains('is-off'),y1=Math.max(y(),y0);
      set(a,b,0,1,s);
      if(y()>y1)set(a,b,k,0,s);else c+=' + tag';
    }
    fitted=c;
    return c;
  }
  var tbs=document.querySelector('.wl-tb__sale');
  function topFits(){
    var box=tbs.querySelector('[data-wl-tbs-box]'),a=tbs.firstElementChild;
    if(!box||!a)return true;
    if(a.scrollWidth>tbs.clientWidth+1||box.scrollWidth>box.clientWidth+1)return false;
    if(tbs.getAttribute('data-wl-fit')==='pill'){var sh=box.querySelector('.wl-tbs__short');if(sh&&(sh.scrollHeight>35||sh.scrollWidth>sh.clientWidth+1))return false}
    return true;
  }
  function topFit(){
    if(!tbs||tbs.hidden||!tbs.getClientRects().length)return '';
    var forms=window.innerWidth<750?['pill']:['full','nolink','short','pill'],i,c='',side=0,u=document.querySelector('.wl-tb__util'),ib=tbs.offsetParent;
    if(window.innerWidth>=750&&u&&ib&&u.getClientRects().length){var ur=u.getBoundingClientRect();if(ur.width)side=Math.max(136,Math.ceil(ib.getBoundingClientRect().right-ur.left)+16)}
    if(side)tbs.style.setProperty('--wl-tbs-side',side+'px');else tbs.style.removeProperty('--wl-tbs-side');
    tbs.classList.remove('is-tight');
    for(i=0;i<forms.length;i++){tbs.setAttribute('data-wl-fit',forms[i]);if(topFits()){c=forms[i];break}}
    if(!c){tbs.classList.add('is-tight');c='pill tight'+(topFits()?'':' (overflow)')}
    return c;
  }
  var fitT,fitW=window.innerWidth;
  function fitSoon(){clearTimeout(fitT);fitT=setTimeout(fit,120)}
  function tick(){
    clearTimeout(timer);
    if(document.hidden)return;
    var n=run();
    if(fitted)fit();
    topFit();
    if(n)timer=setTimeout(tick,Math.min(n+50,60000));
  }
  document.addEventListener('visibilitychange',function(){if(!document.hidden)tick()});
  // transparent home header: the strip lies over the top of the hero, so the hero text moves down by its height (wl-sale.css)
  var st=document.querySelector('[data-header-transparent]')&&document.querySelector('.wl-sale-strip');
  if(st){var setH=function(){document.documentElement.style.setProperty('--wl-sale-strip-h',Math.ceil(st.getBoundingClientRect().height)+'px')};setH();if(window.ResizeObserver)new ResizeObserver(setH).observe(st)}
  window.wlSaleAt=function(ms){off=ms==null?0:ms-Date.now();tick();return new Date(now()).toISOString()};
  window.wlSaleFit=fit;
  window.wlSaleTopFit=topFit;
  tick();
  if(tbs){
    var tf=document.fonts,tw=window.innerWidth;
    if(tf&&tf.ready)tf.ready.then(topFit);
    window.addEventListener('load',topFit);
    window.addEventListener('resize',function(){if(window.innerWidth!==tw){tw=window.innerWidth;topFit()}});
  }
  if(document.querySelector('[data-wl-pill]')){
    var fonts=document.fonts,go=function(){fit();if(fonts&&fonts.status==='loading')fonts.ready.then(fit)};
    if(fonts&&fonts.load)Promise.all([fonts.load("600 13px Montserrat"),fonts.load("700 26px Poppins"),fonts.ready]).then(go,go);else go();
    window.addEventListener('load',function(){if(fitted)fit()});
    window.addEventListener('resize',function(){if(window.innerWidth!==fitW){fitW=window.innerWidth;fitSoon()}});
    var pc=document.querySelector('[data-wl-pill]').closest('.product__content')||document.body;
    if(window.MutationObserver)new MutationObserver(function(ms){for(var i=0;i<ms.length;i++)for(var j=0;j<ms[i].addedNodes.length;j++){var n=ms[i].addedNodes[j];if(n.nodeType===1&&(n.matches('[data-wl-pill]')||n.querySelector('[data-wl-pill]'))){fitSoon();return}}}).observe(pc,{childList:true,subtree:true});
  }
})();
